import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import {useEffect,useState} from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import moment from 'moment-jalali';
import ReactSelect from 'react-select';
import { toast } from 'react-toastify';

const Index = () => {

    const today = () => {
        const today = moment().format('jYYYY-jMM-jDD').split('-');
        return {
            year: +today[0],
            month: +today[1],
            day: +today[2]
        }
    }

    const { readData } = useEntityCrud('Report/getReIssuedCards');
    const { readData: getReasonData } = useEntityCrud('ReIssue/getIssueReason');
    const { readData: getStatusData } = useEntityCrud('ReIssue/getIssueStatus');
    const { readData: getBranchesData } = useEntityCrud('Branch/GetAllBranchs');
    const { readData: getExcelExport } = useEntityCrud('Report/getReIssuedCards');

    const [reasons,setReasons] = useState([]);
    const [statuses,setStatuses] = useState([]);
    const [reasonId,setReasonId] = useState();
    const [branches,setBranches] = useState([]);
    const [branchId,setBranchId] = useState();
    const [isFetchedData,setIsFetchedData] = useState(false);
    const [rows,setRows] = useState([]);
    const [filteredRows,setFilteredRows] = useState([]);
    const [nationalCode,setNationalCode] = useState('');
    const [pan,setPan] = useState('');
    const [isActive,setIsActive] = useState();
    const [fromDate,setFromDate] = useState(today());
    const [toDate,setToDate] = useState(today());

    const [currentPage,setCurrentPage] = useState(1);
    const [pages,setPages] = useState(0);

    const convertToGregorian = date => date.year.toString() + (date.month > 9 ? date.month.toString() : ('0' + date.month)) + (date.day > 9 ? date.day.toString() : ('0' + date.day))

    const calcPages = result => {
        let calcPages = result.length / 10;
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const getData = () => {
        const postedData = {
            p_fromdate: convertToGregorian(fromDate),
            p_todate: convertToGregorian(toDate)
        };
        if(isActive)
            postedData.p_statusid = isActive;
        if(branchId)
            postedData.p_companyid = branchId.toString();
        if(reasonId)
            postedData.p_reasonid = reasonId;
        if(pan && pan.length == 16)
            postedData.p_cardno = pan;
        if(nationalCode && nationalCode.length == 10)
            postedData.p_nationalcode = nationalCode;
        readData(postedData).then(({data}) => {
            if(data.status && data.result && data.result.v_result){
                setRows(data.result.v_result);
                calcPages(data.result.v_result);
                const result = [...data.result.v_result.slice(0,10)]
                setFilteredRows(result);
            }else{
                setRows([]);
                setFilteredRows([]);
            }
        }).finally(() => setIsFetchedData(true));
    }

    useEffect(() => {
        const postedData = {
            offset: 0,
            limit: 1000
        }
        getBranchesData(postedData).then(({data}) => {
            if(data.status){
                const result = data.result.map(i => ({label: i.title, value: i.id}));
                setBranches(result);
            }
        })
        getReasonData().then(({data}) => {
            if(data.status)
                setReasons(data.result)
        })
        getStatusData().then(({data}) => {
            if(data.status)
                setStatuses(data.result)
        })
    },[])

    useEffect(() => {
        getData();
    },[])

    const nextPage = () => {
        const skip = currentPage * 10;
        const result = [...rows.slice(skip,skip + 10)];
        setFilteredRows(result);
        setCurrentPage(currentPage + 1);
    }

    const prevPage = () => {
        const skip = (currentPage - 2) * 10;
        const result = [...rows.slice(skip,skip + 10)];
        setFilteredRows(result);
        setCurrentPage(currentPage - 1);
    }

    const getExcelData = () => {
        document.getElementById('download-excel').classList.add('btn-loading');
        const postedData = {
            p_fromdate: convertToGregorian(fromDate),
            p_todate: convertToGregorian(toDate),
            excelOutput: true,
            limit: 0
        };
        if(isActive)
            postedData.p_statusid = isActive;
        if(branchId)
            postedData.p_companyid = branchId.toString();
        if(reasonId)
            postedData.p_reasonid = reasonId;
        if(pan && pan.length == 16)
            postedData.p_cardno = pan;
        if(nationalCode && nationalCode.length == 10)
            postedData.p_nationalcode = nationalCode;
        getExcelExport(postedData).then(({ data }) => {
            if(data.status)
                window.open(data.excelPath);
            else
                toast.error(data.message);
        }).finally(() => {
            document.getElementById('download-excel').classList.remove('btn-loading');
        })
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">لیست مفقودی کارت</div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>از تاریخ</label>
                            <DatePicker
                                name="fromDate"
                                required
                                locale="fa"
                                shouldHighlightWeekends
                                value={fromDate}
                                onChange={setFromDate}
                                className="form-control"
                                inputPlaceholder='تاریخ  را انتخاب کنید ...'
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>از تاریخ</label>
                            <DatePicker
                                name="toDate"
                                required
                                locale="fa"
                                shouldHighlightWeekends
                                value={toDate}
                                onChange={setToDate}
                                className="form-control"
                                inputPlaceholder='تاریخ  را انتخاب کنید ...'
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>کد ملی</label>
                            <input type="tel" className="form-control ltr-input" maxLength={10} value={nationalCode} onChange={e => setNationalCode(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>شماره کارت</label>
                            <input type="tel" className="form-control ltr-input" maxLength={16} value={pan} onChange={e => setPan(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>شرکت</label>
                            <ReactSelect noOptionsMessage={(e) => "یافت نشد"} placeholder="انتخاب کنید" options={branches} value={branches.filter((b) => b.value == branchId)} onChange={(e) => setBranchId(e.value)} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>وضعیت</label>
                            <select className="form-control" onChange={e => setIsActive(e.target.value)}>
                                <option value="">همه</option>
                                {statuses.map(status => <option value={status.id}>{status.title}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>علت</label>
                            <select className="form-control" onChange={e => setReasonId(e.target.value)}>
                                <option value="">همه</option>
                                {reasons.map(reason => <option value={reason.id}>{reason.title}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-1" style={{marginTop: 30}}>
                        <button className="btn btn-primary btn-block" onClick={getData}>جستجو</button>
                    </div>
                    <div className="col-md-2" style={{marginTop: 30}}>
                        <button className="btn btn-success" id="download-excel" onClick={getExcelData}>دریافت خروجی اکسل</button>
                    </div>
                </div>
                {isFetchedData ? <hr /> : ''}
                {isFetchedData ? (rows.length ? <div className="table-responsive">
                    <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>نام</th>
                                <th>کد ملی</th>
                                <th>مبلغ</th>
                                <th>مرتبه</th>
                                <th>علت</th>
                                <th>تاریخ ثبت</th>
                                <th>تاریخ صدور</th>
                                <th>وضعیت درخواست</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredRows.map((row,index) => <tr key={index}>
                                <td>{(currentPage - 1) * 10 + (index + 1)}</td>
                                <td>{row.fullname}</td>
                                <td>{row.nationalcode}</td>
                                <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(row.price)}</td>
                                <td>{row.cnt}</td>
                                <td>{row.reason}</td>
                                <td>{row.insertdate || '-'}</td>
                                <td>{row.issuedate || '-'}</td>
                                <td>{row.status}</td>
                            </tr>)}
                        </tbody>
                    </table>
                    <p>تعداد کل ردیف ها : {rows.length || 0}</p>
                    {pages.length > 1 && <div className="text-center">
                        <button className="btn btn-primary me-2" disabled={currentPage == 1} onClick={prevPage}>قبلی</button>
                        <button className="btn btn-primary" disabled={currentPage == pages.length} onClick={nextPage}>بعدی</button>
                    </div>}
                </div> : <div className="alert alert-info"><p className="mb-0">درخواستی یافت نشد</p></div>) : ''}
            </div>
        </div>
    )
}

export default Index;